import {checkTokenExists, setToken} from '../helpers/auth';
import {batch} from 'react-redux'
import api from './api';
import localforage from "localforage";

export const SET_USER_DATA = 'SET_USER_DATA';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';


const fetchUser = async () => {
  if (! window.navigator.onLine) {
    return await localforage.getItem('bs_user');
  } else {
    return window.axios.get(api.me)
        .then(({ data: { data } }) => Promise.resolve(data))
        .catch(error => Promise.reject(error));
  }
};

export const updateUserDataRequest = () => dispatch => {
  return fetchUser()
    .then(data => {
      dispatch(updateUserData(data));
      return Promise.resolve(data);
    })
    .catch(error => Promise.reject(error));
}

export const setUserData = user => ({
  type: SET_USER_DATA,
  user
});

export const updateUserData = user => ({
  type: UPDATE_USER_DATA,
  user
});

export const setAuthenticated = authenticated => ({
  type: SET_AUTHENTICATED,
  authenticated
});

export const signInUser = credentials => dispatch => {
  return window.axios.post(api.signin, credentials).then(async ({ data: { data, meta } }) => {
    await setToken(meta.token);

    await localforage.setDriver(localforage.INDEXEDDB);
    await localforage.setItem('bs_user', data);

    dispatch(setUserData(data));
    dispatch(setAuthenticated(true));
    return Promise.resolve({ data, meta });
  }).catch(error => {
    return Promise.reject(error);
  });
};

export const clearAuth = (cb) => dispatch => {
    batch(() => {
      dispatch(setUserData(null));
      dispatch(setAuthenticated(false));
  })
  setToken(null).then(() => { 
    cb();
    dispatch({ type: 'USER_LOGOUT' });
  });
};

export const logoutUser = cb => async dispatch => {
  return window.axios.post(api.logout)
    .then(async response => {
      dispatch(clearAuth(cb));

      await localforage.removeItem('bs_user');
      await localforage.removeItem('bs_company');
      await localforage.removeItem('bs_location');
      await localforage.removeItem('bs_sublocations');
      await localforage.removeItem('bs_removals');
      await localforage.removeItem('bs_instructions');
      await localforage.removeItem('bs_connected_companies');
      await localforage.removeItem('bs_companies');
      await localforage.removeItem('bs_questionaires');

      for (let i = 0; i < 999; i++) {
        if (await localforage.getItem(`bs_locations_${i}`)) {
          await localforage.removeItem(`bs_locations_${i}`);
        }

        if (await localforage.getItem(`bs_sublocations_${i}`)) {
          await localforage.removeItem(`bs_sublocations_${i}`);
        }
      }

    })
    .catch(anyError => {
      dispatch(clearAuth(cb));
    });
};

export const initAuthFromExistingToken = (cb) => dispatch => {
  checkTokenExists().then(token => {
    setToken(token);
    fetchUser().then(data => {
      dispatch(setUserData(data));
      dispatch(setAuthenticated(true));
      cb(data);
    }).catch(anyError => {
      console.log(anyError, 'ERR FETCH USER')
      // if (window.navigator.onLine) {
        dispatch(clearAuth(cb));
      // }
      //cb();
    });
  }).catch(anyError => {
    console.log(anyError, 'ERR TOKEN EXISTS')
    // if (window.navigator.onLine) {
      dispatch(clearAuth(cb));
    // }
    //cb();
  });
};
